import { Input } from 'reactstrap';


function OneErrLog({item, handleEdit}){
    item.checked=false;
    function onEdit(e){
        handleEdit(e,item.errLog_idx);
    };

    function handleChecked(event){
        item.checked=!item.checked;
    }

    
    return (
        <tr >
            <th scope="row" style={{width: "2%"}}><Input type="checkbox" id="chk"  onClick={(e) => handleChecked(e)} /></th>
            <th style={{width: "5%"}}>{item.errLog_idx}</th>
            {/* <td style={{width: "15%"}} onClick={(e) => onEdit(e)}>{item.login_id}</td> */}
            <td style={{width: "15%"}}>{item.login_id}</td>
            <td style={{width: "10%"}}>{item.line_name}</td>
            <td style={{width: "10%"}}>{item.action}</td>
            <td>{item.action_desc}</td>
            {/* <td>{item.agent_type}</td>
            <td>{item.acc_auth}</td>
            <td>{item.exe_auth}</td> */}
            <td style={{width: "12%"}}>{item.reg_date} {item.reg_time}</td>
        </tr>
    );

}

export default OneErrLog;